/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOperationLogs = /* GraphQL */ `
  query GetOperationLogs($LogID: String!) {
    getOperationLogs(LogID: $LogID) {
      LogID
      LogLevel
      UserNo
      Message
      Component
      Function
      Param
      Error
      UserAgent
      Date
      Time
    }
  }
`;
export const listOperationLogs = /* GraphQL */ `
  query ListOperationLogs(
    $LogID: String
    $filter: ModelOperationLogsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOperationLogs(
      LogID: $LogID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        LogID
        LogLevel
        UserNo
        Message
        Component
        Function
        Param
        Error
        UserAgent
        Date
        Time
      }
      nextToken
    }
  }
`;
export const operationLogsByTypeDate = /* GraphQL */ `
  query OperationLogsByTypeDate(
    $LogLevel: String!
    $Date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOperationLogsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationLogsByTypeDate(
      LogLevel: $LogLevel
      Date: $Date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        LogID
        LogLevel
        UserNo
        Message
        Component
        Function
        Param
        Error
        UserAgent
        Date
        Time
      }
      nextToken
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($UserNo: ID!) {
    getUsers(UserNo: $UserNo) {
      UserNo
      Type
      UnionistNo
      SalesNo
      LoginID
      Name
      EMail
      IsSendEmail
      IsDeleted
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $UserNo: ID
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      UserNo: $UserNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        UserNo
        Type
        UnionistNo
        SalesNo
        LoginID
        Name
        EMail
        IsSendEmail
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const usersByTypeUserNo = /* GraphQL */ `
  query UsersByTypeUserNo(
    $Type: Int!
    $UserNo: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByTypeUserNo(
      Type: $Type
      UserNo: $UserNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UserNo
        Type
        UnionistNo
        SalesNo
        LoginID
        Name
        EMail
        IsSendEmail
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const usersByTypeSalesNo = /* GraphQL */ `
  query UsersByTypeSalesNo(
    $Type: Int!
    $SalesNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByTypeSalesNo(
      Type: $Type
      SalesNo: $SalesNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UserNo
        Type
        UnionistNo
        SalesNo
        LoginID
        Name
        EMail
        IsSendEmail
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const usersByTypeUnionistNo = /* GraphQL */ `
  query UsersByTypeUnionistNo(
    $Type: Int!
    $UnionistNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByTypeUnionistNo(
      Type: $Type
      UnionistNo: $UnionistNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UserNo
        Type
        UnionistNo
        SalesNo
        LoginID
        Name
        EMail
        IsSendEmail
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const usersByLoginID = /* GraphQL */ `
  query UsersByLoginID(
    $LoginID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByLoginID(
      LoginID: $LoginID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UserNo
        Type
        UnionistNo
        SalesNo
        LoginID
        Name
        EMail
        IsSendEmail
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getSales = /* GraphQL */ `
  query GetSales($SalesNo: String!) {
    getSales(SalesNo: $SalesNo) {
      SalesNo
      Name
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listSales = /* GraphQL */ `
  query ListSales(
    $SalesNo: String
    $filter: ModelSalesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSales(
      SalesNo: $SalesNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        SalesNo
        Name
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getCommissionHistories = /* GraphQL */ `
  query GetCommissionHistories($CommissionID: String!) {
    getCommissionHistories(CommissionID: $CommissionID) {
      CommissionID
      SalesNo
      Period
      Type
      RegistrationTime
      FilePath
      DLStatus
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listCommissionHistories = /* GraphQL */ `
  query ListCommissionHistories(
    $CommissionID: String
    $filter: ModelCommissionHistoriesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCommissionHistories(
      CommissionID: $CommissionID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        CommissionID
        SalesNo
        Period
        Type
        RegistrationTime
        FilePath
        DLStatus
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const commissionHistoriesByPeriodSalesNo = /* GraphQL */ `
  query CommissionHistoriesByPeriodSalesNo(
    $Period: String!
    $SalesNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommissionHistoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commissionHistoriesByPeriodSalesNo(
      Period: $Period
      SalesNo: $SalesNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        CommissionID
        SalesNo
        Period
        Type
        RegistrationTime
        FilePath
        DLStatus
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getUnionists = /* GraphQL */ `
  query GetUnionists($UnionistNo: String!) {
    getUnionists(UnionistNo: $UnionistNo) {
      UnionistNo
      Name
      SalesNo
      IsSendMail
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listUnionists = /* GraphQL */ `
  query ListUnionists(
    $UnionistNo: String
    $filter: ModelUnionistsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUnionists(
      UnionistNo: $UnionistNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        UnionistNo
        Name
        SalesNo
        IsSendMail
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const unionistsBySalesNo = /* GraphQL */ `
  query UnionistsBySalesNo(
    $SalesNo: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUnionistsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unionistsBySalesNo(
      SalesNo: $SalesNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UnionistNo
        Name
        SalesNo
        IsSendMail
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const unionistsByIsSendMail = /* GraphQL */ `
  query UnionistsByIsSendMail(
    $IsSendMail: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelUnionistsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unionistsByIsSendMail(
      IsSendMail: $IsSendMail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        UnionistNo
        Name
        SalesNo
        IsSendMail
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getCards = /* GraphQL */ `
  query GetCards($CardID: String!) {
    getCards(CardID: $CardID) {
      CardID
      UnionistNo
      SalesNo
      CardType
      IsDeleted
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listCards = /* GraphQL */ `
  query ListCards(
    $CardID: String
    $filter: ModelCardsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCards(
      CardID: $CardID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        CardID
        UnionistNo
        SalesNo
        CardType
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const cardsByUnionistNoCardID = /* GraphQL */ `
  query CardsByUnionistNoCardID(
    $UnionistNo: String!
    $CardID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCardsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cardsByUnionistNoCardID(
      UnionistNo: $UnionistNo
      CardID: $CardID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        CardID
        UnionistNo
        SalesNo
        CardType
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const cardsByUnionistNoCardType = /* GraphQL */ `
  query CardsByUnionistNoCardType(
    $UnionistNo: String!
    $CardType: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCardsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cardsByUnionistNoCardType(
      UnionistNo: $UnionistNo
      CardType: $CardType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        CardID
        UnionistNo
        SalesNo
        CardType
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const cardsBySalesNoUnionistNo = /* GraphQL */ `
  query CardsBySalesNoUnionistNo(
    $SalesNo: String!
    $UnionistNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCardsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cardsBySalesNoUnionistNo(
      SalesNo: $SalesNo
      UnionistNo: $UnionistNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        CardID
        UnionistNo
        SalesNo
        CardType
        IsDeleted
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getCardTypeHistories = /* GraphQL */ `
  query GetCardTypeHistories($Period: String!, $UnionistNoCardType: String!) {
    getCardTypeHistories(
      Period: $Period
      UnionistNoCardType: $UnionistNoCardType
    ) {
      Period
      UnionistNoCardType
      UnionistNo
      CardType
      SalesNo
      RegistrationTime
      FilePath
      UnionistStatus
      MailStatus
      ProxyStatus
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listCardTypeHistories = /* GraphQL */ `
  query ListCardTypeHistories(
    $Period: String
    $UnionistNoCardType: ModelStringKeyConditionInput
    $filter: ModelCardTypeHistoriesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCardTypeHistories(
      Period: $Period
      UnionistNoCardType: $UnionistNoCardType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        Period
        UnionistNoCardType
        UnionistNo
        CardType
        SalesNo
        RegistrationTime
        FilePath
        UnionistStatus
        MailStatus
        ProxyStatus
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const cardTypeHistoriesByUnionistNoPeriod = /* GraphQL */ `
  query CardTypeHistoriesByUnionistNoPeriod(
    $UnionistNo: String!
    $Period: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCardTypeHistoriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cardTypeHistoriesByUnionistNoPeriod(
      UnionistNo: $UnionistNo
      Period: $Period
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        Period
        UnionistNoCardType
        UnionistNo
        CardType
        SalesNo
        RegistrationTime
        FilePath
        UnionistStatus
        MailStatus
        ProxyStatus
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getCarousel = /* GraphQL */ `
  query GetCarousel($id: ID!) {
    getCarousel(id: $id) {
      id
      StartDate
      EndDate
      Sequence
      Body
      Link
      ImgPath
      SequenceSortFlag
      Created
      CreatedBy
      Updated
      UpdatedBy
      createdAt
      updatedAt
    }
  }
`;
export const listCarousels = /* GraphQL */ `
  query ListCarousels(
    $id: ID
    $filter: ModelCarouselFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCarousels(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        StartDate
        EndDate
        Sequence
        Body
        Link
        ImgPath
        SequenceSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCarouselBySequence = /* GraphQL */ `
  query ListCarouselBySequence(
    $SequenceSortFlag: Int!
    $Sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCarouselFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarouselBySequence(
      SequenceSortFlag: $SequenceSortFlag
      Sequence: $Sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        StartDate
        EndDate
        Sequence
        Body
        Link
        ImgPath
        SequenceSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUnionistsNews = /* GraphQL */ `
  query GetUnionistsNews($id: ID!) {
    getUnionistsNews(id: $id) {
      id
      Date
      Time
      UnionistNo
      NewsId
      Title
      Body
      Link
      NotificationEmailSendable
      SentNotificationEmail
      DateTimeNewsIdUnionistNoSortFlag
      Created
      CreatedBy
      Updated
      UpdatedBy
      createdAt
      updatedAt
    }
  }
`;
export const listUnionistsNews = /* GraphQL */ `
  query ListUnionistsNews(
    $id: ID
    $filter: ModelUnionistsNewsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUnionistsNews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Date
        Time
        UnionistNo
        NewsId
        Title
        Body
        Link
        NotificationEmailSendable
        SentNotificationEmail
        DateTimeNewsIdUnionistNoSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUnionistsNewsByDateTimeNewsIdUnionistNo = /* GraphQL */ `
  query ListUnionistsNewsByDateTimeNewsIdUnionistNo(
    $DateTimeNewsIdUnionistNoSortFlag: Int!
    $dateTimeNewsIdUnionistNo: ModelUnionistsNewsI_UnionistsNews_DateTimeNewsIdUnionistNoSortFlagCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnionistsNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnionistsNewsByDateTimeNewsIdUnionistNo(
      DateTimeNewsIdUnionistNoSortFlag: $DateTimeNewsIdUnionistNoSortFlag
      dateTimeNewsIdUnionistNo: $dateTimeNewsIdUnionistNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Date
        Time
        UnionistNo
        NewsId
        Title
        Body
        Link
        NotificationEmailSendable
        SentNotificationEmail
        DateTimeNewsIdUnionistNoSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNews = /* GraphQL */ `
  query GetNews($id: ID!) {
    getNews(id: $id) {
      id
      Date
      Time
      Title
      Body
      Link
      DateTimeSortFlag
      Created
      CreatedBy
      Updated
      UpdatedBy
      createdAt
      updatedAt
    }
  }
`;
export const listNews = /* GraphQL */ `
  query ListNews(
    $id: ID
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Date
        Time
        Title
        Body
        Link
        DateTimeSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listNewsByDateTime = /* GraphQL */ `
  query ListNewsByDateTime(
    $DateTimeSortFlag: Int!
    $dateTime: ModelNewsI_News_DateTimeSortFlagCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewsByDateTime(
      DateTimeSortFlag: $DateTimeSortFlag
      dateTime: $dateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        Date
        Time
        Title
        Body
        Link
        DateTimeSortFlag
        Created
        CreatedBy
        Updated
        UpdatedBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEmailTemplates = /* GraphQL */ `
  query GetEmailTemplates($TemplateType: Int!) {
    getEmailTemplates(TemplateType: $TemplateType) {
      TemplateType
      Subject
      Body
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listEmailTemplates = /* GraphQL */ `
  query ListEmailTemplates(
    $TemplateType: Int
    $filter: ModelEmailTemplatesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEmailTemplates(
      TemplateType: $TemplateType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        TemplateType
        Subject
        Body
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
export const getAutoIncrement = /* GraphQL */ `
  query GetAutoIncrement($Type: Int!) {
    getAutoIncrement(Type: $Type) {
      Type
      CurrentNumber
    }
  }
`;
export const listAutoIncrements = /* GraphQL */ `
  query ListAutoIncrements(
    $Type: Int
    $filter: ModelAutoIncrementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAutoIncrements(
      Type: $Type
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        Type
        CurrentNumber
      }
      nextToken
    }
  }
`;
export const getDownloadWork = /* GraphQL */ `
  query GetDownloadWork($DownloadID: ID!) {
    getDownloadWork(DownloadID: $DownloadID) {
      DownloadID
      StatusCode
      S3Key
      Body
      UpdateCardTypeHistories
      Created
      CreatedBy
      Updated
      UpdatedBy
    }
  }
`;
export const listDownloadWorks = /* GraphQL */ `
  query ListDownloadWorks(
    $DownloadID: ID
    $filter: ModelDownloadWorkFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDownloadWorks(
      DownloadID: $DownloadID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        DownloadID
        StatusCode
        S3Key
        Body
        UpdateCardTypeHistories
        Created
        CreatedBy
        Updated
        UpdatedBy
      }
      nextToken
    }
  }
`;
